import script from "./GroupCheckboxLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupCheckboxLabel.vue?vue&type=script&lang=ts&setup=true"

import "./GroupCheckboxLabel.vue?vue&type=style&index=0&id=c6dfd362&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6dfd362"]])

export default __exports__